module.exports = __webpack_public_path__ + "img/vectorCAST-authentication.62568f02.png";